import type { RootState } from 'js/src/libs/RootState';

export function getAllArticleMedia(state: RootState) {
    return state.article.article_media;
}

export function getArticleMedia(state: RootState, mediaUrl: string) {
    return getAllArticleMedia(state)[mediaUrl];
}

export function selectArticleId(state: RootState) {
    return state.article.article_id;
}

export function selectArticleUrl(state: RootState) {
    return state.article.article_url;
}

export function selectArticleLanguageCode(state: RootState) {
    return state.article.article_language_code;
}
